<div *ngIf="!loading" class="row">
    <div class="col-md-12" *ngIf="!disabled">
        <div class="well well-sm">
            <!--accept="application/rtf, image/jpeg, application/pdf, text/plain, application/vnd.openxmlformats-officedocument.wordprocessingml.document, vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-outlook"
  [allowedFileExtensions]="['.rtf', '.txt', '.docx', '.jpg', '.jpeg', '.pdf', '.msg']"-->
            <dx-file-uploader userRoleNeeded_hidden="Dokumente_Schreiben"
                accept="application/rtf, image/jpeg, application/pdf, text/plain, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/octet-streamm, application/vnd.ms-outlook"
                [allowedFileExtensions]="allowedFileExtensions" (onValueChanged)="addFile($event)" [multiple]="true" selectButtonText="Dateien auswählen (Auswahl mehrerer Dateien gleichzeitig möglich)"
                #fileUploader uploadMode="useForm">
            </dx-file-uploader>
        </div>
    </div>
    <div class="col-md-12 doc-c">

        <dx-data-grid [dataSource]="dataSource" [wordWrapEnabled]="true" [showRowLines]="true" [showBorders]="true"
            [masterDetail]="{ enabled: true, template: 'docDetailTemplate' }"
            (onToolbarPreparing)="onToolbarPreparing($event)" width="100%" height="100%">
            <dxo-sorting mode="single">
            </dxo-sorting>

            <dxo-paging [pageSize]="40"></dxo-paging>
            <dxo-scrolling [useNative]="true" mode="virtual" showScrollbar="always"></dxo-scrolling>

            <dxo-search-panel placeholder="Suche..." [width]="200" [visible]="true"></dxo-search-panel>

            <div *dxTemplate="let data of 'searchBarTemplate1'">
                <div class="toolBarTemplateContainerSelectbox">
                    <div class="dx-field">
                        <div class="dx-field-label">Art:</div>
                        <div class="dx-field-value">
                            <dx-drop-down-box [dataSource]="filterGroupsFormated" [width]="250" displayExpr="name"
                                valueExpr="org" class="toolBarTemplateItem" [(value)]="selectedFilterGroups">
                                <div *dxTemplate="let contentData of 'content'">
                                    <dx-list [dataSource]="filterGroupsFormated" keyExpr="id" selectionMode="all"
                                        [showSelectionControls]="true" (onSelectionChanged)="changeValue($event)"
                                        [(selectedItemKeys)]="selectedFilterGroups">
                                        <div *dxTemplate="let data of 'item'">
                                            <div>{{data.name}}</div>
                                        </div>
                                    </dx-list>
                                </div>
                            </dx-drop-down-box>
                        </div>
                    </div>
                </div>
            </div>

            <div *dxTemplate="let data of 'searchBarTemplate2'">
                <div class="toolBarTemplateContainer">
                    <div class="dx-field">
                        <div class="dx-field-label">Von:</div>
                        <div class="dx-field-value">
                            <dx-date-box [(value)]="von" [width]="150" class="toolBarTemplateItem"
                                (valueChange)="changeValue($event)">
                            </dx-date-box>
                        </div>
                    </div>
                </div>
            </div>

            <div *dxTemplate="let data of 'searchBarTemplate3'">
                <div class="toolBarTemplateContainer">
                    <div class="dx-field">
                        <div class="dx-field-label">Bis:</div>
                        <div class="dx-field-value">
                            <dx-date-box [(value)]="bis" [width]="150" class="toolBarTemplateItem"
                                (valueChange)="changeValue($event)">
                            </dx-date-box>
                        </div>
                    </div>
                </div>
            </div>

            <div *dxTemplate="let doc of 'docDetailTemplate'">
                <div *ngIf="doc.data.items && doc.data.items.length>0">
                    <div class="master-detail-caption"><u><strong>Dokumente</strong></u></div>
                    <dx-data-grid [dataSource]="doc.data.items" [wordWrapEnabled]="true" [showRowLines]="true"
                        [showBorders]="true">

                        <dxi-column [width]="120" alignment="center" [allowResizing]="false" [allowFiltering]="false"
                            [allowSorting]="false" cellTemplate="commandsTemplate1"></dxi-column>
                        <dxi-column [width]="160" alignment="center" dataType="date" dataField="created"
                            format="dd.MM.yyyy - HH:mm:ss" caption="Erstellungsdatum"></dxi-column>
                        <dxi-column [width]="160" alignment="center" dataType="date" dataField="lastModified"
                            format="dd.MM.yyyy - HH:mm:ss" caption="Änderungsdatum"></dxi-column>

                        <dxi-column dataField="bezeichnung" caption="Bezeichnung"></dxi-column>
                        <dxi-column dataField="orgFileName" caption="Datei"></dxi-column>

                        <div *dxTemplate="let data of 'commandsTemplate1'">
                            <cz-download-button userRoleNeeded_hidden="Dokumente_Lesen" title="Download"
                                [fileName]="data.data.name"
                                [fileBezeichnung]="data.data.bezeichnung"></cz-download-button>
                            <cz-document-viewer-popup [fileName]="data.data.name"></cz-document-viewer-popup>
                            <button userRoleNeeded_hidden="Dokumente_Schreiben" title="Bezeichnung bearbeiten"
                                (click)="onEditFile(data.data)" class="btn btn-warning btn-xs" style="margin-left: 3px;"
                                type="button" *ngIf="!disabled"><span class="glyphicon glyphicon-edit"></span></button>
                            <button userRoleNeeded_hidden="Administrator" title="Löschen"
                                (click)="onDeleteFile(data.data)" class="btn btn-danger btn-xs"
                                style="margin-left: 3px;" type="button"><span
                                    class="glyphicon glyphicon-remove"></span></button>
                        </div>


                    </dx-data-grid>
                </div>
            </div>

            <dxi-column [width]="170" alignment="center" [allowResizing]="false" dataField="entityArt"
                caption="Gehört zu" [customizeText]="docType_customizeText"></dxi-column>
            <dxi-column [width]="160" alignment="center" dataType="date" dataField="created"
                format="dd.MM.yyyy - HH:mm:ss" caption="Erstellungsdatum"></dxi-column>
            <dxi-column dataField="bezeichnung" caption="Bezeichnung"></dxi-column>
            <dxi-column [width]="95" alignment="center" [allowResizing]="false" [allowFiltering]="false"
                [allowSorting]="false" cellTemplate="commandsTemplate2"></dxi-column>

            <div *dxTemplate="let data of 'commandsTemplate2'">
                <button userRoleNeeded_hidden="Dokumente_Schreiben" title="Datei hinzufügen"
                    (click)="onAddFileToExist(data.data)" class="btn btn-info btn-xs" type="button"
                    *ngIf="!disabled"><span class="glyphicon glyphicon-plus"></span></button>
                <button userRoleNeeded_hidden="Dokumente_Schreiben" title="Bezeichnung bearbeiten"
                    (click)="onEditMappe(data.data)" class="btn btn-warning btn-xs" style="margin-left: 3px;"
                    type="button" *ngIf="!disabled"><span class="glyphicon glyphicon-edit"></span></button>
                <button userRoleNeeded_hidden="Administrator" title="Löschen" (click)="onDeleteFileMap(data.data)"
                    class="btn btn-danger btn-xs" style="margin-left: 3px;" type="button"><span
                        class="glyphicon glyphicon-remove"></span></button>
            </div>
        </dx-data-grid>
    </div>


    <div *ngIf="showUploadModal">
        <div class="modal-backdrop fade in" [style.display]="showUploadModal ? 'block' : 'none'"></div>
        <div class="modal" tabindex="-1" role="dialog" style="display: block"
            [style.display]="showUploadModal ? 'block' : 'none'">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" aria-label="Close" (click)="showUploadModal = false">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <h4 class="modal-title">Datei-Upload</h4>
                    </div>
                    <div class="modal-body">
                        <dx-form [labelLocation]="'top'" #formUpload [(formData)]="fileNameModelData">
                            <dxi-item [colSpan]="3" dataField="fileBez" [label]="{text: 'Bezeichnung'}">
                                <dxi-validation-rule type="required"
                                    message="Bezeichnung wird benötigt!"></dxi-validation-rule>
                            </dxi-item>
                        </dx-form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-primary"
                            (click)="upload()"><span>Übernehmen</span></button>
                        <button type="button" class="btn btn-sm btn-warning"
                            (click)="onPopupClose($event)"><span>Abbruch</span></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<cz-uploadPopup (onClose)="onPopupClose($event)" (onOkClose)="onPopupCloseOk($event)" [uploadContext]="uploadContext"
    [(popupVisible)]="uploadPopupVisible"></cz-uploadPopup>

<cz-file-bezPopup (onClose)="onPopupClose($event)" [selectedDokument]="selectedDokument"
    [(popupVisible)]="editBezPopupVisible"></cz-file-bezPopup>

<cz-mappe-bezPopup (onClose)="onPopupClose($event)" [selectedMappe]="selectedMappe"
    [(popupVisible)]="mappeBezPopupVisible"></cz-mappe-bezPopup>

<cz-upload-wait (onCancel)="onUploadCancel($event)" [uploadFileName]="uploadFileName" [toUpload]="toUpload"
    [isUploaded]="isUploaded" [(popupVisible)]="uploadWaitPopupVisible"></cz-upload-wait>